module.exports = __webpack_public_path__ + "static/Android_iOS-Still-5b6363ca9bb95e0a1833732aeb61922a.jpg";